module.exports = __webpack_public_path__ + "img/logo10.20042ddb.jpeg";